import type App from "./App";

async function wrapped_request(uri, options) {
  Actions.loadBegin();
  try {
    const res = await fetch(uri, options);
    return await res.json();
  } finally {
    Actions.loadEnd();
  }
}

export default class Actions {
  static APP: App;

  static vision_key = "AIzaSyAIEQsuM08MpwlA_Ze7p1YE_4VKwIfjPDg";

  static load_counter = 0;
  static loadBegin() {
    Actions.load_counter++;
    if (Actions.load_counter === 1) {
      Actions.APP.setState({ loading: true });
    }
  }
  static loadEnd() {
    Actions.load_counter--;
    if (Actions.load_counter < 0) {
      Actions.load_counter = 0;
      console.warn("load<0?");
    }
    if (Actions.load_counter === 0) {
      Actions.APP.setState({ loading: false });
    }
  }

  static async updateVisionAction(originalLang : string, data: string) {
    const js_key = Actions.vision_key;

    var json = await wrapped_request(
      "https://vision.googleapis.com/v1/images:annotate?key=" + js_key,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          requests: [
            {
              features: [{ type: "TEXT_DETECTION" }],
              image: { content: data },
              imageContext: {
                languageHints:
                originalLang === "_detect"
                    ? []
                    : [originalLang]
              }
            }
          ]
        })
      }
    );

    Actions.APP.setState({ translatedText: null, annotations: json.responses[0].textAnnotations || [] });
  }

  static clearTranslation() {
    Actions.APP.setState({ translatedText: null });
  }  
  static async translateAction(
    target_lang: string,
    txt: string,
    source_lang: ?string
  ) {
    const js_key = Actions.vision_key;

    txt = txt.trim();
    const cache_key = [target_lang, source_lang];
    if(Actions.APP.state.translatedCache && Actions.APP.state.translatedCache[cache_key]) {
      if(Actions.APP.state.translatedCache[cache_key][txt]) {
          Actions.APP.setState({
            translatedText: Actions.APP.state.translatedCache[cache_key][txt]
          });
          return;
      }
    }

    Actions.APP.setState({
        translatedText: "Please wait..."
    });
      
    var json = await wrapped_request(
      "https://translation.googleapis.com/language/translate/v2?key=" +
        js_key +
        "&format=text&target=" +
        target_lang +
        "&q=" +
        encodeURIComponent(txt) +
        (source_lang !== "_detect" ? "&source=" + encodeURIComponent(source_lang) : "")
    );

    const existingCache = (Actions.APP.state.translatedCache && Actions.APP.state.translatedCache[cache_key]) || {};
    Actions.APP.setState({
      translatedText: json.data.translations[0].translatedText,
      translatedCache: {
        [cache_key]: {
          ...existingCache,
          [txt]: json.data.translations[0].translatedText
        }
      }
    });
  }
  
  static async loadLangsAction() {
    const js_key =  Actions.vision_key;
    var res = await fetch(
      "https://translation.googleapis.com/language/translate/v2/languages?key=" +
        js_key +
        "&target=" +
        (navigator.language.split("-")[0] || "en")
    );
    var json = await res.json();
    Actions.APP.setState({ langs: json.data.languages });
  }  
}



// WEBPACK FOOTER //
// ./src/actions.js